<template>
  <div>
    <template v-for="(row, index) in bill_payments">
      <div class="row" :key="index">
        <!-- <div class="col-10 order-first col-md-5">
            <select-input
              v-model="row.payment_method"
              :alias="'Parcela ' + (index + 1)"
              :placeholder="'Forma de Pg'"
              :options="paymentOptions[operation]"
            />
          </div> -->
        <div class="col-md-2">
          <text-input v-model="row.document" :alias="'Documento'" />
        </div>
        <div class="col-md-2">
          <number-input
            v-model="row.value"
            :alias="'Valor'"
            :placeholder="'Valor'"
          />
        </div>
        <div class="col-md-2">
          <date-input v-model="row.due_date" :alias="'Vencimento'"></date-input>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">&nbsp;</label>
            <br />
            <button
              v-if="canDeleteRow"
              class="btn btn btn-light"
              @click="removeRow(index)"
            >
              <i class="text-info fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </template>
    <div class="row">
      <div class="col-md-6">
        <button class="btn btn-link text-info" @click="addRow()">
          <i class="fas fa-plus" /> Adicionar parcela
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {

  props : {
    value : {}
  },
  
  components: {},

  data: function () {
    return {
      bill_payments: [
        {
          document: null,

          payment_method: 1,

          value: null,

          due_date: null,
        },
      ],
    };
  },

  watch: {
    value: function (val) {
      this.bill_payments = val
    },

    bill_payments: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
  },

  computed: {
    canDeleteRow() {
      return this.bill_payments.length > 1;
    },
  },

  methods: {
    addRow() {
      this.bill_payments.push({
        document: null,

        payment_method: 1,

        value: null,

        due_date: null,
      });
    },

    removeRow(index) {
      this.$delete(this.bill_payments, index);
    },
  },
};
</script>

<style>
</style>